import React, { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import axios from "axios"
import { FaBars } from 'react-icons/fa'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Alert from 'react-bootstrap/Alert'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Select from 'react-select'
import { apiURL, sitePath } from 'config/globals'
import Sidebar from 'components/Sidebar'
import Footer from 'components/Footer'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import moment from "moment"
import ReactImagePickerEditor from 'react-image-picker-editor'
import 'react-image-picker-editor/dist/index.css'
import { checkAuth } from 'utils/Auth'

const TableNew = () => {
    const [currentUser, setCurrentUser] = useState(false)
    const [tableInfo, setTableInfo] = useState([])
    const [form, setForm] = useState({})
    const [submitError, setSubmitError] = useState('')
    const navigate = useNavigate()
    const { tableName } = useParams()
    
    useEffect(() => {
        const start = async () => {
            setCurrentUser(await checkAuth(navigate))
            getTableInfo()
        }
        start()
    }, [])

    const getTableInfo = async () => {
        const response = await axios.get(`${apiURL}/get-table-info/${tableName}`)
        setTableInfo(response.data)
    }

    const handleChange = (field, value) => {
        setForm({
            ...form,
            [field]: value
        })
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        event.stopPropagation()
        const response = await axios.post(`${apiURL}/create-table-item/${tableName}`, form)
        if (!response.data) {
            return
        }
        if (response.data.success) {
            navigate(`/tables/${tableName}`)
        }
        if (response.data.error) {
            setSubmitError(response.data.message)
        }
    }

    const getOptionLabel = (option, columnName) => {
        return option[Object.keys(tableInfo.options[columnName][0])[1]]
    }

    const isSelect = (column) => {
        return Object.keys(tableInfo.options).includes(column.name) && column.type === "int"
    }

    const isMultiSelect = (column) => {
        return Object.keys(tableInfo.options).includes(column.name) && column.type === "multi"
    }

    const isCheckbox = (column) => {
        return column.type === "tinyint"
    }

    const isTextarea = (column) => {
        return column.type === "longtext"
    }

    const isDate = (column) => {
        return column.type === "date"
    }

    const isDateTime = (column) => {
        return column.type === "datetime"
    }

    const isImage = (column) => {
        return column.type === "int" && column.comment === "IMAGE"
    }

    const isDocument = (column) => {
        return column.type === "int" && column.comment === "DOCUMENT"
    }
    
    return (
        <>
            <Sidebar selectedItem={`table/${tableName}`} currentUser={currentUser} />
            <main>
                <Breadcrumb>
                    <Breadcrumb.Item href={`${sitePath}/dashboard`}>Inici</Breadcrumb.Item>
                    <Breadcrumb.Item active>Taules</Breadcrumb.Item>
                    <Breadcrumb.Item href={`${sitePath}/tables/${tableName}`}>{tableName}</Breadcrumb.Item>
                    <Breadcrumb.Item active>Nou element</Breadcrumb.Item>
                </Breadcrumb>
                <div className="btn-toggle">
                    <FaBars />
                </div>
                <header>
                    <h1>{tableName}</h1>
                </header>
                {tableInfo.columns &&
                    <Row>
                        <Col lg xl="8">
                            <Form onSubmit={handleSubmit}>
                                {tableInfo.columns.filter(x => x.name !== "id").map(column => (
                                    <Form.Group as={Row} key={column.name} className="mb-3" controlId={column.name}>
                                        <Form.Label column sm="4" className="fw-bold">
                                            {column.name}
                                        </Form.Label>
                                        <Col sm="8">
                                            {
                                                (() => {
                                                    if (isSelect(column)) return (
                                                        <Form.Select
                                                            name={column.name}
                                                            defaultValue={column.default}
                                                            onChange={e => handleChange(e.target.name, e.target.value)}
                                                        >
                                                            {tableInfo.options[column.name]
                                                                .map(option => (
                                                                    <option key={option.id} value={option.id}>
                                                                        {getOptionLabel(option, column.name)}
                                                                    </option>
                                                                ))
                                                            }
                                                        </Form.Select>
                                                    )

                                                    if (isMultiSelect(column)) return (
                                                        <Select
                                                            name={column.name}
                                                            options={tableInfo.options[column.name]
                                                                .filter(option => option.id !== tableInfo.columns.find(x => x.name === column.name).default)
                                                                .map(option => (
                                                                { 
                                                                    value: option.id,
                                                                    label: getOptionLabel(option, column.name)
                                                                }))
                                                                .sort((a, b) => { return a.label < b.label })
                                                            }
                                                            isMulti="true"
                                                            onChange={(selected, props) => handleChange(props.name, selected.map(x => x.value))}
                                                        />
                                                    )

                                                    if (isCheckbox(column)) return (
                                                        <Form.Check 
                                                            type="checkbox"
                                                            name={column.name}
                                                            className="mt-1"
                                                            onChange={e => handleChange(e.target.name, e.target.value === "on" ? 1 : 0)}
                                                        />
                                                    )

                                                    if (isTextarea(column)) return (
                                                        <Form.Control
                                                            name={column.name}
                                                            as="textarea"
                                                            rows={6}
                                                            onChange={e => handleChange(e.target.name, e.target.value)}
                                                        />
                                                    )

                                                    if (isDate(column)) return (
                                                        <DatePicker
                                                            dateFormat="yyyy-MM-dd"
                                                            className="datePicker"
                                                            onChange={date => {
                                                                handleChange(column.name, date
                                                                    ? moment(date).format('YYYY-MM-DD')
                                                                    : null
                                                                )
                                                            }}
                                                            selected={form[column.name]
                                                                ? new Date(form[column.name])
                                                                : null
                                                            }
                                                        />
                                                    )

                                                    if (isDateTime(column)) return (
                                                        <DatePicker
                                                            showTimeSelect
                                                            timeFormat="HH:mm"
                                                            timeIntervals={15}
                                                            timeCaption="Hora"
                                                            dateFormat="yyyy-MM-dd HH:mm"
                                                            className="datePicker"
                                                            onChange={date => {
                                                                handleChange(column.name, date
                                                                    ? moment(date).format('YYYY-MM-DD HH:mm')
                                                                    : null
                                                                )
                                                            }}
                                                            selected={form[column.name]
                                                                ? new Date(form[column.name])
                                                                : null
                                                            }
                                                        />
                                                    )

                                                    if (isImage(column)) return (
                                                        <div className="mb-3">
                                                            <ReactImagePickerEditor
                                                                config={{
                                                                    borderRadius: '8px',
                                                                    language: 'en',
                                                                    width: '330px',
                                                                    height: '250px',
                                                                    objectFit: 'contain',
                                                                    compressInitial: null,
                                                                }}
                                                                imageChanged={(dataUri) => {
                                                                    handleChange(column.name, {
                                                                        uri: dataUri
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                    )

                                                    if (isDocument(column)) return (
                                                        <div className="mb-3">
                                                            <input type="file" onChange={(event) => {
                                                                const file = event.target.files[0]
                                                                const reader = new FileReader();
                                                                reader.onloadend = () => {
                                                                    handleChange(column.name, {
                                                                        uri: reader.result,
                                                                        name: file.name
                                                                    })
                                                                };
                                                                reader.readAsDataURL(file)
                                                            }} />
                                                        </div>
                                                    )
                                                    
                                                    return (
                                                        <Form.Control
                                                            name={column.name}
                                                            onChange={e => handleChange(e.target.name, e.target.value)}
                                                        />
                                                    )
                                                })()
                                            }
                                        </Col>
                                    </Form.Group>
                                ))}
                                <div className="d-grid">
                                    <Button type="submit" variant="primary" className="my-4" block="true">
                                        Guardar
                                    </Button>
                                </div>
                                {submitError && 
                                    <Alert key='submitError' variant='danger'>
                                        {submitError}
                                    </Alert>
                                }
                            </Form>
                        </Col>
                    </Row>
                }
                <Footer user={currentUser} />
            </main>
        </>
    )
}

export default TableNew